import { combineReducers } from 'redux';
import leftMenu from './left-menu';

export default combineReducers({
  leftMenu
});
